import { render } from "./TherapyCustomerManagement.vue?vue&type=template&id=31d3a21a&scoped=true"
import script from "./TherapyCustomerManagement.vue?vue&type=script&lang=js"
export * from "./TherapyCustomerManagement.vue?vue&type=script&lang=js"

import "./TherapyCustomerManagement.vue?vue&type=style&index=0&id=31d3a21a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d3a21a"]])

export default __exports__